import { Button, ButtonProps, HStack, Text } from "@chakra-ui/react";
import { FC } from "react";
import SpinnerComponent from "../../Spinner/SpinnerComponent";

interface LoadingButtonProps extends ButtonProps {
  isLoading: boolean;
  isButtonDisabled?: boolean;
}

const LoadingButton: FC<LoadingButtonProps> = ({
  isLoading,
  isButtonDisabled = false,
  children,
  ...props
}) => {
  return (
    <Button {...props} isDisabled={isButtonDisabled || isLoading}>
      {isLoading ? (
        <HStack gap="2">
          <Text fontWeight="bold">A carregar...</Text>
          <SpinnerComponent />
        </HStack>
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
